export const DATE_FORMAT = {
  STANDARD: 'yyyy-MM-dd',
  STANDARD_FULLMONTH: 'yyyy MMM dd',
  STANDARD_DBSAVE: 'yyyy-MM-dd HH:mm:ss',
  STANDARD_AU_TIME: 'dd-MM-yyyy HH:mm',
  STANDARD_AU_NOTIME: 'dd/MM/yyyy',
  STANDARD_AU_FULLMONTH: 'dd MMM yyyy',
  STANDARD_AU_FULLMONTH_TIME: 'dd MMM yyyy hh:mm a',
  STANDARD_ISO: "yyyy-MM-dd'T'HH:mm:ss.SSSX",
  STANDARD_ISO_TIME: "yyyy-MM-dd'T'HH:mm:ss",
  PARTNER_PLAN_LIST: "dd MMM yyyy 'at' hh:mm a",
  PARTNER_PLAN_DOCLIST: "dd MMM yyyy 'at' hh:mm a",
  PARTNER_PLAN_FORM: "dd MMM yyyy 'at' hh:mm a",
  EXPORT_STANDARD: 'ddMMyyyy',
  SPO_FORMAT: 'dd/MM/yyyy hh:mm:ss a',
}

export const TIME_FORMAT = {
  CONVERSATION_LIST: 'h:mma',
}



// WEBPACK FOOTER //
// ./src/constants/date.js